import React from 'react';
import classSet from 'react-classset';

const PlayerControl = ({imgSrc, label, onClick, disabled}) => {

  const playerControlClasses = classSet({
    'ssc__player-control': true,
    'ssc__control-disabled': disabled
  });

  return (
    <div className={playerControlClasses} onClick={onClick}>
      <img src={imgSrc} alt={label} />
      <span>{label}</span>
    </div>
  );
  
}

export default PlayerControl;


// WEBPACK FOOTER //
// ./src/components/PlayerControl/PlayerControl.js